/**
 * Tag of the related custom notices list served by `getRelatedCustomNotices`.
 *
 * The list is derived from an entity's relation graph, not from its own record, so it goes
 * stale whenever a relation to another notice-bearing entity is linked or unlinked (customer,
 * vehicle, business case, service order, ...). Every mutation that edits such a link has to
 * invalidate this tag, otherwise the notices panel only catches up after a page reload.
 */
export const RELATED_CUSTOM_NOTICES_TAG = {type: 'CustomNotice', id: 'RELATED_LIST'} as const;
